import { render, staticRenderFns } from "./AuthHandler.vue?vue&type=template&id=c4286eca&scoped=true"
import script from "./AuthHandler.vue?vue&type=script&lang=ts"
export * from "./AuthHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4286eca",
  null
  
)

export default component.exports